import { PRODUCT_RATING, PRODUCT_REVIEWS, REVIEW_DETAILS } from '@estee/elc-service-view-names';
import { IAppConfig, ServiceInitializer } from '@estee/elc-universal-utils';
import { Service } from '@estee/elc-service';

import { serviceNames, diContainer } from './diContainer';
import { RatingsReviewsServiceStartedUseCase } from '../internal/use-cases/RatingsReviewsServiceStartedUseCase';

const { name, version } = __serviceInfo__;

export class RatingsReviewsService extends Service {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
        this.registerView(
            PRODUCT_RATING,
            () =>
                import(
                    /* webpackChunkName: 'ProductRating' */
                    '../exported/product-rating/ProductRating'
                ),
            () => diContainer.get(serviceNames.productRatingViewController)
        );
        this.registerView(
            PRODUCT_REVIEWS,
            () =>
                import(
                    /* webpackChunkName: 'ProductReviews' */
                    '../exported/product-reviews/ProductReviews'
                ),
            () => diContainer.get(serviceNames.productReviewsViewController)
        );
        this.registerView(
            REVIEW_DETAILS,
            () =>
                import(
                    /* webpackChunkName: 'ReviewDetails' */
                    '../exported/review-details/ReviewDetails'
                ),
            () => diContainer.get(serviceNames.reviewDetailsViewController)
        );
    }

    public async start(config: IAppConfig) {
        const service = await super.start(config);

        const useCase = new RatingsReviewsServiceStartedUseCase(['ratingsReviewsConfig', 'brand']);
        await useCase.execute();

        return service;
    }
}
